import { useLocation } from "react-router-dom";

export default function Statistics() {
  const location = useLocation();
  const isSuccessStoriesPage = location.pathname.includes("/success-stories");
  const isLivePage = location.pathname.includes("/live");

  const stats = isSuccessStoriesPage
    ? [
        {
          value: "$50M+",
          label: "Revenue Recouped",
          color: "#34C759",
        },
        {
          value: "3,500+",
          label: "Creators Protected",
          color: "#34C759",
        },
        {
          value: "100K+",
          label: "Claims Processed",
          color: "#34C759",
        },
      ]
    : [
        {
          value: "$50M+",
          label: "Revenue Recouped",
          color: isLivePage ? "#9146FF" : "#FF6B35",
        },
        {
          value: "3,500+",
          label: "Creators Protected",
          color: isLivePage ? "#9146FF" : "#FF6B35",
        },
        {
          value: "100%",
          label: "Free to use",
          color: isLivePage ? "#9146FF" : "#FF6B35",
        },
      ];

  return (
    <div className="bg-white  px-6 md:px-16 flex items-center justify-center">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto ">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-16 md:gap-28 lg:gap-[250px] xl:gap-[150px] 2xl:gap-[200px] 1xl:gap-[200px] bg-white border border-[#eee] rounded-[10px] px-16 md:px-20 lg:px-[170px] xl:px-[100px] 2xl:px-20 1xl:px-20 py-5 w-fit mx-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="flex flex-col gap-1.5 items-center text-center w-[117px] lg:w-[1px] xl:w-[150px] 2xl:w-[150px] 1xl:w-[170px]"
            >
              <div
                className="text-5xl md:text-6xl font-semibold leading-none"
                style={{ color: stat.color }}
              >
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-nowrap text-[rgba(0,0,0,0.5)]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
